import './index.scss'
import '../../assets/scripts/jQuery.positionSticky.min.js'
import LocomotiveScroll from 'locomotive-scroll'


let ismobile = $(window).width() > 767 ? true : false
let scroller

$(window).resize(function(){
  ismobile = $(window).width() > 767 ? true : false;
  location.reload();
})

$(document).ready(function(){
  let head = ismobile ? $('.header').height()+20 : $('.header').height();
  $('.section2 .pro_cont .left_search').positionSticky({offsetTop: head});
})

$(document).on('click','.section2 .pro_cont .left_search .contonts .sort', function(){
  if(!ismobile){
    if($(this).hasClass('active')){
      $(this).removeClass('active')
    }else{
      $(this).addClass('active')
    }
    $(this).siblings('ul').slideToggle();
  }
})
$(document).on('click','.section2 .pro_cont .left_search .ti', function(){
  if(!ismobile){
    if($(this).hasClass('active')){
      $(this).removeClass('active')
    }else{
      $(this).addClass('active')
    }
    $(this).siblings('.seartext').slideToggle();
  }
})



